import React from "react";
import { useSelector } from "react-redux";
import { AssumptionQuestions, PageLayout, WarningBox } from "../../components";
import { useAssumptions } from "./useAssumptions";
import { getSourceSystemIsCNP } from "../../store/selectors/AppraisalSlice";
import { useNavigate } from "react-router-dom";
import { questionRoutingLabels } from "../../data/QuestionPresentation";
const Assumptions = () => {
  const {
    stepNumber,
    quickValuation,
    fullValuation,
    quickValuationQuestions,
    firstConditionQuestion,
    assumptionQuestions,
    answersChanged,
    handleSubmit,
    handleChange,
    selectedQuestionsHaveChanged,
    updateQuestionAnswers,
    showGlassPhotoIncreaseWarning,
    handleCheckboxChange,
    checkboxState,
    analyticSearchParam,
  } = useAssumptions();
  const isCnp = useSelector(getSourceSystemIsCNP);

  const navigate = useNavigate();

  return (
    <PageLayout>
      <PageLayout.Header title="Review assumptions" step={stepNumber} />
      <PageLayout.Content>
        <>
          <div className="ch-mb--4">
            <h4 className="ch-fs--4 ">Review assumptions</h4>
            <p className="ch-fs--3">
              Making updates to these assumptions may change your valuation.
            </p>
          </div>

          {quickValuation && !fullValuation ? (
            <>
              <AssumptionQuestions
                questions={quickValuationQuestions}
                handleChange={handleChange}
                selectedQuestionsHaveChanged={selectedQuestionsHaveChanged}
                handleCheckboxChange={handleCheckboxChange}
                checkboxState={checkboxState}
                analyticSearchParam={analyticSearchParam}
              />
              <div className="ch-pa--3 ch-bg--white ch-ba--1 ch-rounded ch-bc--grey-3 ch-shadow--sm ch-mv--5">
                <p className="ch-fs--4">Review the car's condition</p>
                <ul className="ch-list ch-list--tick ch-measure">
                  <li>Bodywork is free from imperfections</li>
                  <li>All tyres have 3mm tread</li>
                  <li>All wheels are in good condition</li>
                  <li>Interior and glass are free from imperfections</li>
                  <li>Mechanical and electrical parts are fully functional</li>
                </ul>

                <button
                  className="ch-btn ch-btn--primary ch-btn--block ch-mt--3"
                  onClick={async () => {
                    await updateQuestionAnswers();
                    if (isCnp) {
                      navigate("/branch/condition");
                    } else {
                      navigate(
                        `/${questionRoutingLabels[firstConditionQuestion]}`
                      );
                    }
                  }}
                >
                  Update vehicle condition
                </button>
              </div>
            </>
          ) : (
            <AssumptionQuestions
              questions={assumptionQuestions}
              handleChange={handleChange}
              selectedQuestionsHaveChanged={selectedQuestionsHaveChanged}
              handleCheckboxChange={handleCheckboxChange}
              checkboxState={checkboxState}
              analyticSearchParam={analyticSearchParam}
            />
          )}
          {answersChanged && (
            <WarningBox
              showGlassPhotoIncreaseWarning={showGlassPhotoIncreaseWarning}
            />
          )}
        </>
      </PageLayout.Content>
      <PageLayout.Footer>
        <button
          className="ch-btn ch-btn--success ch-display--block ch-mh--auto sm:ch-width--6 md:ch-width--5 ch-width--12 lg:ch-width--4"
          type="button"
          onClick={handleSubmit}
        >
          {answersChanged ? "Change and update offer" : "OK"}
        </button>
      </PageLayout.Footer>
    </PageLayout>
  );
};

export default Assumptions;
